<template>
  <div>
    <BaseFrame>
      <div slot="content">
        <lk-card>
          <lk-table border :columns="columns" :data="tableData"></lk-table>
          <div class="mt8" style="text-align: right;">
            <lk-page
              show-sizer
              show-elevator
              show-total
              :total="count"
              :current="page"
              :page-size="size"
              @on-change="handlePage"
              @on-page-size-change="handlePageSize">
            </lk-page>
          </div>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';

export default {
  name: 'StockAllCountDetail',
  components: {
    BaseFrame,
  },
  data() {
    return {
      bizTypes: new Map([
        [1, '验收入库'],
        [2, '销售退货'],
        [3, '盘点报溢'],
        [4, '销售出库'],
        [5, '供应商退货'],
        [6, '药品报损'],
        [7, '盘点报损'],
        [8, '药品召回'],
        [13, '采购成本调整'],
        [14, '销售成本调整'],
        [15, '其他成本调整'],
        [20, '拆零出库'],
        [21, '拆零入库'],
      ]),
      page: 1,
      size: 20,
      count: 0,
      tableData: [],
      columns: [
        {
          title: '业务类型',
          key: 'inventoryRecordBizType',
          minWidth: 116,
          render: (h, { row }) => h('span', this.bizTypes.get(row.inventoryRecordBizType)),
        },
        {
          title: '日期',
          key: 'inventoryRecordCreateTime',
          minWidth: 116,
          render: (h, { row }) => h('span', utils.formatDate(row.inventoryRecordCreateTime)),
        },
        {
          title: '数量',
          key: 'inventoryRecordGoodsQuantity',
          minWidth: 116,
        },
        {
          title: '批号',
          key: 'inventoryInfoGoodsBatchNumber',
          minWidth: 116,
        },
        {
          title: '生产日期',
          key: 'inventoryInfoGoodsProductionDate',
          minWidth: 116,
          render: (h, { row }) => h('span', utils.exchangeTime(row.inventoryInfoGoodsProductionDate)),
        },
        {
          title: '有效日期',
          key: 'inventoryInfoGoodsExpiryDate',
          minWidth: 116,
          render: (h, { row }) => h('span', utils.exchangeTime(row.inventoryInfoGoodsExpiryDate)),
        },
        {
          title: '仓库',
          key: 'inventoryInfoWarehouseName',
          minWidth: 116,
        },
        {
          title: '货位',
          key: 'inventoryInfoLocationCode',
          minWidth: 116,
        },
      ],
    };
  },
  computed: {},
  methods: {
    getData() {
      const params = JSON.parse(decodeURI(this.$route.params.ids));
      params.size = this.size;
      params.page = this.page;
      inventory.getAllCountDetails(params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          this.tableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 切换每页显示的条数
    handlePageSize(val) {
      this.size = val;
      this.getData();
    },

    // 切换页面
    handlePage(val) {
      this.page = val;
      this.getData();
    },
  },
  created() {
    if (this.$route.params.ids) {
      this.getData();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
